import {apiUserLink} from "@pg-mono/rp-api-routes";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {rpApi} from "../../app/api/rp_api";

/**
 * Full property payload for the tinder details card, served in the KM detail
 * format through `/user-api/proxy/properties/property/:id/`.
 */
export const getHomematchPropertyApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomematchProperty: builder.query<IPropertyDetailDTO, {propertyRpId: number}>({
            query: ({propertyRpId}) => ({
                url: apiUserLink.homeMatch.property({propertyId: propertyRpId})
            })
        })
    }),
    overrideExisting: false
});

export const {useGetHomematchPropertyQuery} = getHomematchPropertyApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {rpApi} from "../../app/api/rp_api";

/**
 * Full property payload for the tinder details card, served in the KM detail
 * format through `/user-api/proxy/properties/property/:id/`.
 */
export const getHomematchPropertyApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomematchProperty: builder.query<IPropertyDetailDTO, {propertyRpId: number}>({
            query: ({propertyRpId}) => ({
                url: apiUserLink.homeMatch.property({propertyId: propertyRpId})
            })
        })
    }),
    overrideExisting: false
});

export const {useGetHomematchPropertyQuery} = getHomematchPropertyApi;
